// libraries.
import { Card, Alert, Spinner } from 'react-bootstrap';
import { monserratSemiBold, robotoRegular } from '@habitech/shared';

// hooks.
import { useCurrentOrchestrator } from '../../hooks/useCurrentOrchestrator';
import { useMaxPrice } from '../../hooks/useMaxPrice';

// utils.
import { formatPrice } from '@shared/utils';

export const MaxPriceDisplay = () => {
  const { currentOrchestrator, rawNid } = useCurrentOrchestrator();
  const { isLoading, isError, data } = currentOrchestrator;
  const { precioMaximo, precioMaximoComision, found } = useMaxPrice(data);

  if (!rawNid) {
    return (
      <Card className="mt-3">
        <Card.Body>
          <Alert variant="info" className="mb-0">
            <div style={{ fontFamily: robotoRegular }}>
              Por favor ingresa un NID en el buscador para consultar el precio máximo.
            </div>
          </Alert>
        </Card.Body>
      </Card>
    );
  }

  if (isLoading) {
    return (
      <Card className="mt-3">
        <Card.Body className="text-center">
          <Spinner animation="border" role="status" variant="primary">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
          <div className="mt-2" style={{ fontFamily: robotoRegular }}>
            Cargando información del orquestador...
          </div>
        </Card.Body>
      </Card>
    );
  }

  if (isError) {
    return (
      <Card className="mt-3">
        <Card.Body>
          <Alert variant="danger" className="mb-0">
            <div style={{ fontFamily: robotoRegular }}>
              Error al cargar el orquestador. Verifica que el NID sea correcto.
            </div>
          </Alert>
        </Card.Body>
      </Card>
    );
  }

  if (!data) {
    return (
      <Card className="mt-3">
        <Card.Body>
          <Alert variant="warning" className="mb-0">
            <div style={{ fontFamily: robotoRegular }}>
              No se encontró información para el NID ingresado.
            </div>
          </Alert>
        </Card.Body>
      </Card>
    );
  }

  if (!found) {
    return (
      <Card className="mt-3">
        <Card.Body>
          <Alert variant="warning" className="mb-0">
            <div style={{ fontFamily: robotoRegular }}>
              No se encontró el proceso "idm ensamble de precio" o no tiene información de precio máximo disponible.
            </div>
          </Alert>
        </Card.Body>
      </Card>
    );
  }

  return (
    <div className="mt-3">
      <Card>
        <Card.Header>
          <div style={{ fontFamily: monserratSemiBold, fontSize: '18px' }}>
            Información de Precios - NID: {data.nid}
          </div>
        </Card.Header>
        <Card.Body>
          <div className="d-flex flex-column gap-4">
            {precioMaximo !== null && (
              <div className="d-flex flex-column gap-2">
                <div style={{ fontFamily: monserratSemiBold, fontSize: '16px' }}>
                  Compraventa
                </div>
                <Card className="border-success">
                  <Card.Body className="bg-light">
                    <div className="d-flex justify-content-between align-items-center">
                      <span style={{ fontFamily: robotoRegular, fontSize: '14px' }}>
                        Precio Máximo:
                      </span>
                      <span
                        style={{
                          fontFamily: monserratSemiBold,
                          fontSize: '24px',
                          color: '#28a745',
                        }}
                      >
                        {formatPrice(precioMaximo)}
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            )}

            {precioMaximoComision !== null && (
              <div className="d-flex flex-column gap-2">
                <div style={{ fontFamily: monserratSemiBold, fontSize: '16px' }}>
                  Comisión
                </div>
                <Card className="border-primary">
                  <Card.Body className="bg-light">
                    <div className="d-flex justify-content-between align-items-center">
                      <span style={{ fontFamily: robotoRegular, fontSize: '14px' }}>
                        Precio Máximo:
                      </span>
                      <span
                        style={{
                          fontFamily: monserratSemiBold,
                          fontSize: '24px',
                          color: '#007bff',
                        }}
                      >
                        {formatPrice(precioMaximoComision)}
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            )}

            <div className="mt-2">
              <Card className="border-secondary">
                <Card.Body>
                  <div style={{ fontFamily: robotoRegular, fontSize: '12px', color: '#6c757d' }}>
                    <strong>Información adicional:</strong>
                    <div className="mt-2">
                      <div>País: {data.country}</div>
                      <div>Property ID: {data.property_id}</div>
                      <div>Workflow: {data.workflow_alias}</div>
                      <div>Estado: {data.status}</div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};
